import { AnalysisStatus } from '../contract-ai-analysis/contract-ai-analysis.model';

// ===== Objektive Finanzanalyse (ai service, FIN-7165) =====
export type CashflowFindingStatus = 'OK' | 'WARN';
export type CashflowFindingAction =
  | 'NONE'
  | 'CONTACT_CLIENT'
  | 'FINANZCHECK'
  | 'VERTRAGSCHECK'
  | 'WIEDERVORLAGE'
  | 'SPARPLAN'
  | 'VINSAFE_DEPOT'
  | 'VINSAFE_INTRO';

export interface CashflowFinding {
  status: CashflowFindingStatus;
  category: string;
  priority: number;
  title: string | null;
  text: string;
  monthlyEffectEur: number | null;
  action: CashflowFindingAction;
  actionLabel: string | null;
  /** Ready-to-send chat draft in Du form, only for CONTACT_CLIENT */
  clientMessage: string | null;
  messageSentAt: string | null;
}

export interface CashflowAnalysisResult {
  analysisUid: string;
  advisorId: string;
  clientId: string;
  status: AnalysisStatus;
  months: number;
  summaryText: string | null;
  findings: CashflowFinding[];
  advisorNotes: string[];
  vinsafeEnabled: boolean | null;
  modelUsed: string | null;
  errorMessage: string | null;
  createdAt: string;
  completedAt: string | null;
}

export interface CashflowAnalysisRequest {
  months?: number;
  advisorNotes?: string[];
  /** advisor app setting 'Vinsafes Investment Depots'; undefined = unknown */
  vinsafeEnabled?: boolean;
  /** existing Vinsafe pockets of the client; undefined = unknown */
  vinsafePockets?: number;
}

export interface CashflowMessageRequest {
  message: string;
  findingIndex: number | null;
}

export interface CashflowAdvisorNotes {
  notes: string[];
  updatedAt: string | null;
}

export type CashflowStatus = 'POSITIVE' | 'NEGATIVE' | 'GOOD';

export type CashflowAnalysisStatus = 'COMPLETE' | 'RUNNING' | 'FAILED';

export interface CashflowAnalysisSummary {
  /** Number of listed bank-connected clients (not only AI-analysed ones) */
  analyzedClients: number;
  negativeCashflowClients: number;
  averageMonthlyCashflow: number | null;
  averageSavingsRate: number | null;
  recommendedSavingsRate: number;
}

export interface CashflowAnalysisClient {
  clientId: string;
  clientName: string;
  /** Status of the latest AI 'Objektive Finanzanalyse'; null = never started for this client */
  analysisStatus: CashflowAnalysisStatus | null;
  cashflowStatus: CashflowStatus | null;
  averageCashflow: number | null;
  averageIncome: number | null;
  averageSpending: number | null;
  savingsRate: number | null;
  monthlySavings: number | null;
  liquidityReserve: number | null;
  months: number | null;
  /** When the latest AI analysis ran; null = never */
  lastAnalysisAt: string | null;
}

export interface CashflowAnalysisOverview {
  summary: CashflowAnalysisSummary;
  clients: CashflowAnalysisClient[];
  page: number;
  pageSize: number;
  total: number;
  totalPages: number;
}

export interface CashflowAnalysisOverviewParams {
  search: string | null;
  status: CashflowStatus | null;
  page: number;
  pageSize: number;
}
